// react
import React from 'react';

// material ui icons
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

// material ui
// Card that takes children components to display in a dashboard layout
// It will take a title, descripiton (to be in tooltip), and optional action  buttons, an icon and then display the children
import {
  alpha,
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  Tooltip,
  Typography,
} from '@mui/material';
const DashboardCard = (props) => {
  const {
    title,
    description,
    children,
    icon,
    actions,
    sx,
    iconColor = '#96b100',
    iconBgColor = '#c2dd00',
  } = props;
  return (
    <Card sx={sx}>
      <CardHeader
        avatar={
          <Avatar
            variant="rounded"
            sx={{
              bgcolor: () => alpha(iconBgColor, 0.1),
              borderRadius: 3,
            }}
          >
            {icon &&
              React.cloneElement(icon, {
                sx: { verticalAlign: 'middle', color: iconColor },
              })}
          </Avatar>
        }
        action={actions}
        title={
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography variant="h6">{title}</Typography>
            {description && (
              <Tooltip title={description} placement="top">
                <InfoOutlinedIcon
                  fontSize="small"
                  sx={{ color: (theme) => theme.palette.text.secondary }}
                />
              </Tooltip>
            )}
          </Box>
        }
      />
      <CardContent sx={{ pb: 0 }}>{children}</CardContent>
    </Card>
  );
};

export default DashboardCard;

